import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { t } from 'i18next';

const ButtonGroupOverview = props => (
    <Button color="primary" tag={props.tag ? props.tag : Link} to={props.to} className={'btn-labeled ' + props.className} onClick={props.onClick}>
        <span className="btn-label"><i className={'fa fa-' + (props.icon ? props.icon : 'calendar-alt')} aria-hidden></i></span>
        {props.children ? props.children : t('group:groupOverviewButton')}
    </Button>
)

export default ButtonGroupOverview;